(function () {
	// Copy
	document.querySelectorAll('.js-copy-btn').forEach(btn => {
		btn.setAttribute('data-clipboard-text', window.location.href);
	});

	const clipboard = new ClipboardJS('.js-copy-btn');

	clipboard.on('success', function (e) {
		if (e.trigger.querySelector('.copy-msg')) return;

		// New DOM
		const newDiv = document.createElement("div");
		const newContent = document.createTextNode("Copied!");
		newDiv.appendChild(newContent);
		newDiv.classList.add('copy-msg');
		e.trigger.appendChild(newDiv);

		setTimeout(() => {
			newDiv.classList.add('is-show');
		}, 50);

		setTimeout(() => {
			newDiv.classList.remove('is-show');
		}, 1500);

		setTimeout(() => {
			newDiv.remove();
		}, 2000);

		e.clearSelection();
	});


	// Rellax
	window.addEventListener('load', function () {
		new Rellax('.js-rellax');
	});
})();
